import { Link } from 'react-router-dom';
import '../styles/landing.css';
import CompanyWhatWeDo from './CompanyWhatWeDo';
import VideoPhysicalDesign from './VideoPhysicalDesign';

function Landing() {
  // const onClickOwlHandler = () => {
  //   console.log('you clicked the image');
  // };

  let audioOwl = new Audio('/sounds/owl_hoot_B1.mp3');
  // let audio = new Audio('/sounds/Ahhh2.mp3');

  const playOwlSound = () => {
    audioOwl.play();
  };

  // const onClickWolfHandler = () => {
  //   console.log('you clicked the image');
  // };

  let audioWolf = new Audio('/sounds/wolf_boris_2.m4a');
  // let audio = new Audio('/sounds/Ahhh2.mp3');

  const playWolfSound = () => {
    audioWolf.play();
  };

  return (
    <main className="page main-content">
      {/* <CompanyWhatWeDo /> */}
      <hr></hr>
      <section className="img-centered">
        <div className="sleeping-with-sDevice"></div>
      </section>
      <div className="hero-stripe">
        <div className="stripe-container-gutter-free">
          <div className="hero-container">
            <img
              className="hero-image"
              src="/images/lady-side-sleeping-lamp-left-half2.png"
              alt="lady sleeping on her side"
            />
            <div className="hero-details">
              <div className="stripe-header">
                We are developing a <br />
                novel positional therapy approach
                <br />
                for obstructive sleep apnea (OSA)
                <br />
                and snoring...
                <br />
                named <span className="accent_standard">WhisperPT</span>
              </div>
              <div className="stripe-copy">
                WhisperPT is based on the simple concept
                <br /> that patients with OSA and snoring deserve
                <br /> a treatment that is <br />
                comfortable, inexpensive, and effective.
              </div>
              {/* <div className="hero-copy">
                WhisperPT for Snoring
                <br />
              </div> */}
              {/* 
              <Link to="/learn-more">
                <div className="hero-button">learn more</div>{' '}
              </Link> */}
            </div>
          </div>
        </div>
      </div>
      <div className="stripe color-stripe">
        <div className="stripe-container">
          <div className="stripe-contents">
            <div className="stripe-header">
              OSA is pervasive, dangerous, and addressable
              <div className="stripe-copy">
                <ul>
                  <li>~1 billion people worldwide have OSA </li>
                  <li>
                    OSA is associated with heart disease, stroke, type 2
                    diabetes, and dementia{' '}
                  </li>
                  <li>
                    50–75% experience a ≥50% reduction in OSA with positional
                    therapy (PT){' '}
                    <span className="citation">
                      <a
                        href="https://pubmed.ncbi.nlm.nih.gov/31325020/"
                        target="blank"
                        alt="Oksenberg et al., Sleep. 2000; Cartwright RD. Chest. 1984; de Vries et al., Chest. 2015"
                      >
                        (1)
                      </a>
                    </span>
                  </li>
                  <li>
                    30% have their OSA fully resolved with with PT
                    <span className="citation">
                      <a
                        href="https://jcsm.aasm.org/doi/10.5664/jcsm.7868"
                        target="blank"
                        alt="Berry RB et. Al., NightBalance sleep position treatment device versus auto-adjusting positive airway pressure for treatment of positional obstructive sleep apnea. J Clin Sleep Med. 2019;15(7):947–956."
                      >
                        (2)
                      </a>
                    </span>
                  </li>
                </ul>
              </div>
            </div>
            <div className="stripe-header">
              We've engineered the smallest and most comfortable positional
              therapy device for OSA!
              <br />
            </div>
            <div className="engineered-to-the-smallest-scale-container">
              <div>
                <div class="image-container">
                  <img
                    className="image lady-sleeping-device"
                    src="/images/product/V3_HeadShot.jpg"
                    alt="lying on back in deep sleep, soft palate and tongue collapse"
                    height="500px"
                  />
                  <img
                    className="image lady-sleeping-device"
                    src="/images/product/V3_Close_Up.jpg"
                    alt="lying on back in deep sleep, soft palate and tongue collapse"
                    height="500px"
                  />
                </div>

                <center>
                  <div className="stripe-copy">
                    with a 1/2 inch body diameter and encased in soft silicone
                    <br />
                    It is small, comfortable, and discreet
                  </div>
                </center>
              </div>
            </div>

            {/* <div className="engineered-to-the-smallest-scale-container">
              <div>
                <center>
                  <div>
                    <div>
                      <VideoPhysicalDesign />
                    </div>
                  </div>
                </center>
              </div>
            </div> */}
            <br />
          </div>
        </div>
      </div>

      <div className="stripe">
        <div className="stripe-container">
          <div className="stripe-contents">
            <div className="stripe-header">
              Sleeping on the back increases OSA events
            </div>
            <div className="stripe-copy">
              For most OSA sufferers, sleeping on their back will cause their
              tongues and soft palates to fall to the back of the throat and
              block their airway.
            </div>
            <div className="sleeping-on-back-images-container">
              <div>
                <img
                  className="image"
                  src="/images/lying-on-back-in-place.gif"
                  alt="lying on back awake, soft palate and tongue stay in place"
                  width="250px"
                />
                <div className="caption">
                  as they lie down, <br />
                  the muscles hold the <br />
                  tongue and soft palate in place
                  <hr class="heavily-faded mobile-only" />
                </div>
              </div>
              <div>
                <img
                  className="image"
                  src="/images/lying-on-back-deep-sleep-collapsed.gif"
                  alt="lying on back in deep sleep, soft palate and tongue collapse"
                  width="250px"
                />
                <div className="caption">
                  when in deep sleep, <br />
                  the tongue and soft palate
                  <br />
                  collapse into their airway
                  <hr class="heavily-faded mobile-only" />
                </div>
              </div>
            </div>
            <br />
          </div>
        </div>
      </div>
      <div className="stripe color-stripe">
        <div className="stripe-container">
          <div className="stripe-contents">
            <div className="stripe-header positional-therapy-opens">
              Positional therapy prevents back sleeping reducing apnea events
              and severity
            </div>
            <div className="stripe-copy">
              Positional therapy (PT) keeps OSA sufferers sleeping on their side
              where the tongue and soft palate can stay clear of their airway,
              allowing them to breathe more freely.
            </div>
            <img
              className="side-sleeping-picture"
              src="/images/side-sleeping-mid-slice.jpg"
              alt="pleasant moment side sleeping"
              width="100%"
            />
          </div>
        </div>
      </div>
      <div className="stripe">
        <div className="stripe-container">
          <div className="stripe-contents">
            <div className="stripe-header">
              We've developed a positional therapy device using sound cues
            </div>
            <div className="stripe-copy">
              Our patent-pending technology uses sound cues to notify sleepers
              when they roll onto and stop on their back. Since people primarily
              roll while in a light sleep, which is also when they are
              responsive to sound, our technology is designed to play soft
              notification sounds and guide them off their back without waking
              them.{' '}
            </div>
            <div className="max-benefit-container">
              <div className="icon-container">
                <center>
                  <img
                    className="icon-image"
                    src="/images/icons/ear-blue-256x256.png"
                    alt="ear icon"
                    width="40px"
                  />
                </center>
                <div className="icon-caption">
                  gentle sounds
                  <br />
                  guide the sleeper into side sleeping
                  <br />
                  before apnea events even start
                </div>
              </div>

              <div className="icon-container">
                <center>
                  <img
                    className="icon-image side-icon"
                    src="/images/icons/on-side-blue-256x256.png"
                    alt="ear icon"
                    width="50px"
                  />
                </center>
                <div className="icon-caption">
                  reliable positional therapy
                  <br />
                  keeps them off their back
                  <br />
                  even in their deepest sleep
                </div>
              </div>

              <div className="icon-container">
                <center>
                  <img
                    className="icon-image"
                    src="/images/icons/cues-blue-256x256.png"
                    alt="sound cues icon"
                    width="40px"
                  />
                </center>
                <div className="icon-caption">
                  dozens of pleasant
                  <br />
                  audio cues
                  <br />
                  to choose between
                </div>
              </div>
            </div>

            <div className="max-benefit-container">
              <div className="icon-container">
                <center>
                  <img
                    className="icon-image"
                    src="/images/icons/tiny-design-blue-256x256.png"
                    alt="tiny icon"
                    width="40px"
                  />
                </center>
                <div className="icon-caption">
                  tiny design
                  <br />
                  fits in the ear comfortably
                  <br />
                  through the night
                </div>
              </div>

              <div className="icon-container">
                <center>
                  <img
                    className="icon-image"
                    src="/images/icons/app-blue-256x256.png"
                    alt="app icon"
                    width="40px"
                  />
                </center>
                <div className="icon-caption">
                  use presets, customizable
                  <br />
                  cue volume, and patterns
                  <br />
                  to align WhisperPT to their sleep
                </div>
              </div>

              <div className="icon-container">
                <center>
                  <img
                    className="icon-image"
                    src="/images/icons/improve-blue-256x256.png"
                    alt="improvement icon"
                    width="40px"
                  />
                </center>
                <div className="icon-caption">
                  tune and improve their sleep
                  <br />
                  through logging and
                  <br />
                  auto-suggestions
                </div>
              </div>
            </div>
            <br />
          </div>
        </div>
      </div>

      {/* <div className="stripe color-stripe">
        <div className="stripe-container">
          <div className="stripe-contents">
            <div className="stripe-header">
              We've engineered the smallest and most comfortable positional
              therapy device for sleep!
              <br />
            </div>
            <div className="engineered-to-the-smallest-scale-container">
              <div>
                <div class="image-container">
                  <img
                    className="image lady-sleeping-device"
                    src="/images/product/V3_HeadShot.jpg"
                    alt="lying on back in deep sleep, soft palate and tongue collapse"
                    height="500px"
                  />
                  <img
                    className="image lady-sleeping-device"
                    src="/images/product/V3_Close_Up.jpg"
                    alt="lying on back in deep sleep, soft palate and tongue collapse"
                    height="500px"
                  />
                </div>

                <center>
                  <div className="stripe-copy">
                    with a 1/2 inch body diameter and encased in soft silicone
                    <br />
                    It is small, comfortable, and discreet
                  </div>
                </center>
              </div>
            </div>
            <br />
          </div>
        </div>
      </div> */}

      <div className="stripe color-stripe">
        <div className="stripe-container">
          <div className="stripe-contents">
            <div className="stripe-header">
              User WhisperPT sleep tests shows positional adherence and customer
              interest
              <br />
            </div>
            <div className="engineered-to-the-smallest-scale-container">
              <div>
                {' '}
                <center>
                  <img
                    className="image graph"
                    src="/images/product/Customer_Response_Data_Zoomed-in(dark).jpg"
                    alt="lying on back in deep sleep, soft palate and tongue collapse"
                    width="100%"
                  />

                  <div className="caption">
                    WhisperPT Sleep data demonstrating a tester responding to
                    the treatment and maintaining a side sleeping position
                  </div>
                </center>
              </div>
            </div>
            <br />
          </div>
        </div>
      </div>

      <div className="stripe">
        <div className="stripe-container">
          <div className="stripe-contents">
            <div className="stripe-header">
              WhisperPT has not yet been cleared by the FDA
            </div>
            <br />
            <div className="stripe-copy">
              We have developed multiple functional prototypes of WhisperPT,
              with the latest versions successfully completing in-house Phase 1
              testing. We are now preparing for clinical trials and planning to
              submit a 510(k) application to the FDA.
              <p>
                &nbsp;
                <p />
                <p></p>
                Until WhisperPT receives FDA clearance, it cannot be sold in the
                United States.{' '}
              </p>
            </div>
            <br />
          </div>
        </div>
      </div>
    </main>
  );
}
export default Landing;
